export enum FieldSource {
  CSV = 'csv',
  FLOWZZ = 'flowzz',
  AI = 'ai',
  MISSING = 'missing',
}
